const EnvironmentConfigs = () => {
  let authConfiguration: any = localStorage.getItem("authConfiguration");
  if (authConfiguration) {
    authConfiguration = JSON.parse(authConfiguration);
  }

  const clientId =
    window._env_?.VITE_CLIENT_ID || import.meta.env.VITE_CLIENT_ID;

  return {
    appAuthorityBaseUrl:
      window._env_?.VITE_AUTHORITY || import.meta.env.VITE_AUTHORITY,

    wellKnownConfiguration:
      window._env_?.VITE_WELL_KNOWN_CONFIGURATION ||
      import.meta.env.VITE_WELL_KNOWN_CONFIGURATION,

    clientId,

    scope: window._env_?.VITE_CLIENT_SCOPE || import.meta.env.VITE_CLIENT_SCOPE,

    oidcStorageName: `oidc.user:${
      authConfiguration?.authorization_endpoint || ""
    }:${clientId || ""}`,

    cookieDomain:
      window._env_?.VITE_SET_COOKIE_DOMAIN ||
      import.meta.env.VITE_SET_COOKIE_DOMAIN,

    meetUrl:
      window._env_?.VITE_MEET_BASE_URL || import.meta.env.VITE_MEET_BASE_URL,
  };
};

export default EnvironmentConfigs;
